export type NavRoute = {
  label: string;
  route: string;
  icon?: string;
  translationKey: string;
  children?: NavRoute[];
};

export const sidenavRoutes: NavRoute[] = [
  // {
  //   label: 'Asiakkaat',
  //   route: 'customers',
  //   icon: 'customer',
  //   translationKey: 'NAV.CUSTOMERS',
  //   children: [
  //     {
  //       label: 'Lopputuoteasiakkaat',
  //       route: 'end',
  //       translationKey: 'NAV.END_PRODUCT_CUSTOMERS'
  //     },
  //     {
  //       label: 'Raatokeräilyasiakkaat',
  //       route: 'carcass-collection',
  //       translationKey: 'NAV.CARCASS_COLLECTION_CUSTOMERS'
  //     }
  //   ]
  // },
  {
    label: 'Kumppanit',
    route: 'partners',
    icon: 'partner',
    translationKey: 'NAV.PARTNERS',
    children: [
      {
        label: 'Teurastamot',
        route: 'slaughterhouses',
        translationKey: 'NAV.SLAUGHTERHOUSES'
      },
      {
        label: 'Logistiikka',
        route: 'logistics',
        translationKey: 'NAV.LOGISTICS'
      }
    ]
  },
  {
    label: 'Tuotteet',
    route: 'products',
    icon: 'product',
    translationKey: 'NAV.PRODUCTS',
    children: [
      {
        label: 'Sivutuotteet',
        route: 'byproducts',
        translationKey: 'NAV.BYPRODUCTS'
      }
      // {
      //   label: 'Lopputuotteet',
      //   route: 'end-products',
      //   translationKey: 'NAV.END_PRODUCTS'
      // }
    ]
  },
  {
    label: 'Palvelut',
    route: 'services',
    icon: 'service',
    translationKey: 'NAV.SERVICES'
  }
];
